import { put, takeLatest, fork, take } from 'redux-saga/effects';
import type { AnyAction } from 'redux';
import type { ActionPattern } from 'redux-saga/effects';
import { HttpErrorBaseAction } from '../../types';
import { httpError, validationErrors } from './actionCreators';

// [{"field": null, "code": "STORE_BUSINESS_DATE_OPEN"}]
function* handleRequestErrors(actions: HttpErrorBaseAction<unknown>) {
  if (actions.error.notified) return;
  if (actions.error.code === 400 && actions.error.data && Array.isArray(actions.error.data)) {
    const errors = actions.error.data.map(i => ({ field: i.field, code: i.code }));
    yield put(validationErrors(errors));
  } else {
    yield put(httpError(actions.error));
  }
}
const isFailureAction: ActionPattern<AnyAction> = (action: AnyAction) =>
  /Failure$/i.test(action.type);

function* watchRequestErrors() {
  yield takeLatest(isFailureAction, handleRequestErrors);
}

export default [fork(watchRequestErrors)];
